import { DateString, dateStringSerializer, Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";
import Decimal from "decimal.js";

import { currencies, Currency, Gtin, gtinSerializer } from "../common";

export type NewOrderChargeInput = {
  itemNumber: string;
  quantity: Decimal;
  price: Decimal;
};

export type NewOrderInput = {
  charges?: NewOrderChargeInput[];
  sellToCustomerUuid: Uuid;
  billToCustomerUuid: Uuid;
  payerDepartmentUuid: Uuid;
  orderDate: DateString;
  currency: Currency;
  comment: string;
  externalDocumentNumber: string;
  lines: NewOrderLineInput[];
  shipToCity?: string;
  shipToPostCode?: string;
  shipToAddressLine1?: string;
  shipToAddressLine2?: string;
  shipToCountry?: string;
  requestedDeliveryDate?: Date;
};

type NewOrderLineInput = {
  gtin: Gtin;
  quantity: Decimal;
  price: Decimal;
  discountRate: Decimal;
};

export const newOrderLineInputSerializer = MSerializers.object<NewOrderLineInput>({
  gtin: gtinSerializer,
  quantity: MSerializers.decimal,
  price: MSerializers.decimal,
  discountRate: MSerializers.decimal,
});

export const newOrderInputSerializer = MSerializers.object<NewOrderInput>({
  charges: MSerializers.array(
    MSerializers.object<NewOrderChargeInput>({
      itemNumber: MSerializers.string,
      quantity: MSerializers.decimal,
      price: MSerializers.decimal,
    }),
  ).optional(),
  comment: MSerializers.string,
  payerDepartmentUuid: uuidSerializer,
  sellToCustomerUuid: uuidSerializer,
  billToCustomerUuid: uuidSerializer,
  shipToCity: MSerializers.string.optional(),
  shipToPostCode: MSerializers.string.optional(),
  externalDocumentNumber: MSerializers.string,
  shipToAddressLine1: MSerializers.string.optional(),
  shipToAddressLine2: MSerializers.string.optional(),
  shipToCountry: MSerializers.string.optional(),
  requestedDeliveryDate: MSerializers.dateOnly.optional(),
  lines: MSerializers.array(newOrderLineInputSerializer),
  orderDate: dateStringSerializer,
  currency: MSerializers.stringOneOf(...currencies),
});
